export default __webpack_public_path__ + "static/media/black-circle-measure-icon.42e87fad.svg";